import styled from 'styled-components';
export const WizardSummaryCards = styled.div `
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: 12px;
  height: 100%;
  overflow: auto;
`;
